import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Link } from 'components/core/Link';

export default function Crumb({
	children, label, href, isLast, segmentLabel, segmentProperties, to, tertiary, className
}) {
	return React.createElement(
		!isLast ? Link : Text,
		{
			to,
			href,
			segmentLabel,
			segmentProperties,
			secondary: !tertiary,
			tertiary: !isLast && tertiary,
			color: isLast && tertiary && 'white',
			className
		},
		children || label
	);
}

Crumb.propTypes = {
	children: PropTypes.node,
	label: PropTypes.string.isRequired,
	href: PropTypes.string,
	isLast: PropTypes.bool,
	segmentLabel: PropTypes.string,
	segmentProperties: PropTypes.object,
	to: PropTypes.string,
	tertiary: PropTypes.bool,
	className: PropTypes.string
};
